module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/health_citizen_science_studies_logo-b79748e38dededd1481ff0fa5ab1f3dc.svg";